import { Switch, SwitchProps } from '@chakra-ui/core'
import styled from '@emotion/styled'
import { RootState } from 'constants/interfaces'
import React from 'react'
import { useSelector } from 'react-redux'

const StyledSwitch = styled(Switch)<{ switchColorActive?: string; switchColorInactive?: string }>`
  & > input:checked + div {
    background-color: ${({ switchColorActive }) => switchColorActive || 'teal'} !important;
  }
  & > input + div {
    background-color: ${({ switchColorInactive }) => switchColorInactive || '#dadada'};
  }

  & > input[type='checkbox']:focus {
    outline: none !important;
    box-shadow: none !important;
  }

  & {
    outline: none !important;
    box-shadow: none !important;
  }

  & > div {
    box-shadow: none !important;
  }
  & > div:focus {
    box-shadow: none !important;
  }

  & > input[type='checkbox']:focus-visible + div {
    outline: 2px solid #222222;
    outline-offset: 3px;
  }

  & > input[type='checkbox']::-moz-focus-inner {
    border: 0 !important;
  }
  margin-bottom: 0 !important;
`

export interface ControlledSwitchProps extends Omit<SwitchProps, 'onChange'> {
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  activeColor?: string
  inactiveColor?: string
}

export const ControlledSwitch: React.FC<ControlledSwitchProps> = ({
  activeColor,
  inactiveColor,
  size = 'sm',
  ...props
}) => {
  const theme = useSelector((state: RootState) => state.general?.theme)

  return (
    <StyledSwitch
      dir="ltr"
      switchColorActive={activeColor || theme?.elementsColor}
      switchColorInactive={inactiveColor}
      size={size}
      {...props}
    />
  )
}
